(ns dashboard.views
  (:require
   [reagent.core :as reagent]
   [clojure.string :refer [split lower-case]]
   [re-frame.core :as re-frame]
   [breaking-point.core :as bp]
   [headlessui-reagent.core :as ui]
   [dashboard.i18n :refer [tr]]
   [dashboard.db :as db]
   [dashboard.demo-cartier :as demo]
   [dashboard.subs :as subs]
   [dashboard.events.auth0 :as auth0]
   [dashboard.utils :refer [listen index-by]]
   [dashboard.components.navbar :as navbar]
   [dashboard.components.button :refer [button]]
   [dashboard.components.login :as login]
   [dashboard.components.notification :refer [notification]]
   [dashboard.components.guide :refer [guide]]
   [dashboard.components.footer :refer [footer]]
   [dashboard.components.radiogroup :refer [radio-group]]
   [dashboard.views.home :as home]
   [dashboard.views.reports :as reports]
   [dashboard.views.settings :as settings]
   [dashboard.views.rooms :as rooms]))

(defn loading-page []
  [:div.bg-white.min-h-screen.px-4.py-16.sm:px-6.sm:py-24.md:grid.md:place-items-center.lg:px-8
   [:div.max-w-max.mx-auto
    [:main.sm:flex
     [:span.text-green-500.opacity-75.my-0.mx-auto.block.relative
      {:class "top-1/2"}
      [:svg.animate-spin.-ml-1.mr-3.h-20.w-20.text-primary
       {:class ""
        :xmlns "http://www.w3.org/2000/svg"
        :fill "none"
        :viewBox "0 0 24 24"}
       [:circle.opacity-25
        {:cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
       [:path.opacity-75
        {:fill "currentColor"
         :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]]]]])

(defn login-page []
  [:div.min-h-screen.flex.items-center.justify-center.bg-light-grey4.py-12.px-4.sm:px-6.lg:px-8
   [login/auth0-link]])

(defn main-panel []
  (if (listen ::subs/loading?)
    [loading-page]
    [:div.min-h-full.bg-gray-50.font-cartier
     [:div.relative.pb-32.overflow-hidden.bg-primary-500 ;; .bg-gradient-to-r.from-primary-500.to-red-500
      ;; Navbar
      [:nav.bg-transparent.z-10.border-b.border-neutral-300.border-opacity-25.lg:bg-primary-500.lg:border-none.lg:fixed.lg:top-0.lg:left-0.lg:right-0.z-20
       {:aria-label "Primary Nav"}
       [navbar/nav]]

      ;; Header
      [:header.relative.py-4.sm:py-10.mt-2.sm:mt-12
       [:div.max-w-7xl.mx-auto.px-4.sm:px-6.lg:px-8
        [:h1.text-3xl.font-bold.text-white
         (tr (listen ::subs/current-route-title))]]]]
     [:main.-mt-32.relative
      [:div.max-w-7xl.mx-auto.pb-8.px-4.sm:px-6.lg:px-8
       (case (namespace (listen ::subs/current-route-name))
         "route.home" [home/content]
         "route.rooms" [rooms/content]
         "route.settings" [settings/content]
         [:div])]]
     [footer]
     [guide
      {:state (listen ::subs/user-guide)}]
     [notification
      (listen ::subs/notification)]]))
